import * as React from 'react';
import { UIComponentViewImpl } from '../../uicomponentview';
import { UIDataModel, UIComponentState, UIComponentHandler } from '../../uicomponent';
import { ArtistRowComponentProps, ArtistRowComponentHandler } from './artistrowcomponent';
import { EnglishArtistRowCSSStyle } from './englishartistrowcss';
import { ImageLoaderComponent } from '../../imageloader/imageloadercomponent';
import { ArtistRowImageLoaderCSSStyleImpl } from './artistrowimageloadercss';
import { ImageLoaderCSSStyle } from '../../imageloader/imageloadercss';
import { BaseContext } from '../../../../utils/basecontext';

export class ArtistRowViewImpl extends UIComponentViewImpl<UIDataModel>
{
  private imageLoaderCSSStyle: ImageLoaderCSSStyle;
   constructor(context: BaseContext, handler: UIComponentHandler)
   {
       super(context, handler);

       this.imageLoaderCSSStyle = new ArtistRowImageLoaderCSSStyleImpl(context);
   }

    draw(props: ArtistRowComponentProps, state: UIComponentState, cssStyle: EnglishArtistRowCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
          <tr style={cssStyle.getWrapperCSSStyle()}>
            <td style={cssStyle.getToneImageDivCSSStyle()}>

                  <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.artistDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/>
            </td>
            <td style={cssStyle.getContentDivCSSStle()}>
                  <div style={cssStyle.getArtistNameCSSStyle()}>
                    {props.artistDto.getArtistName()}
                  </div>
            </td>
            <td style={cssStyle.getActionDivCSSStyle()} onClick={(()=>{(this.getUIComponentHandler() as ArtistRowComponentHandler).onArtistRowSelected();})}>
                  <img style={cssStyle.getActionImageCSSStyle()} width="16px" height="10.67px" src={this.getContext().getResources().getImage('eye.svg')}/>
            </td>
          

          </tr>
         
        );
    }
    
  
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/artist/artistrowview.tsx